// extracted by mini-css-extract-plugin
export default {"error":"BoardNameInput_error__61ply"};